import React, { useEffect, useState } from "react";
import axios from "axios";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const ENV_API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const API = `${ENV_API_BASE_URL}/api/teacher-training`;

function TeacherTraining() {
  const [data, setData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);

  const [formData, setFormData] = useState({
    mainHeading: "",
    subHeading: "",
    paragraph: "",
    video: null,
  });

  // ================= FETCH =================
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get(API);
      setData(res.data.data || res.data); // safe fallback
    } catch (error) {
      console.error("FETCH ERROR:", error);
    }
  };

  // ================= INPUT =================
  const handleChange = (e) => {
    if (e.target.name === "video") {
      setFormData({
        ...formData,
        video: e.target.files[0],
      });
    } else {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
  };

  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    const sendData = new FormData();

    sendData.append("mainHeading", formData.mainHeading || "");
    sendData.append("subHeading", formData.subHeading || "");
    sendData.append("paragraph", formData.paragraph || "");

    if (formData.video) {
      sendData.append("video", formData.video);
    }

    try {
      if (editId) {
        await axios.put(`${API}/${editId}`, sendData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
        await axios.post(API, sendData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      // RESET
      setShowForm(false);
      setEditId(null);
      setFormData({
        mainHeading: "",
        subHeading: "",
        paragraph: "",
        video: null,
      });

      fetchData();
    } catch (error) {
      console.error("SAVE ERROR:", error.response?.data || error.message);
    }
  };

  // ================= EDIT =================
  const handleEdit = (item) => {
    setEditId(item._id);
    setShowForm(true);

    setFormData({
      mainHeading: item.mainHeading || "",
      subHeading: item.subHeading || "",
      paragraph: item.paragraph || "",
      video: null,
    });
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API}/${id}`);
      fetchData();
    } catch (error) {
      console.error("DELETE ERROR:", error);
    }
  };

  return (
    <div className="container pt-5 mt-5">
      {!showForm && (
        <>
          <button
            className="btn btn-primary mb-3"
            onClick={() => setShowForm(true)}
          >
            Create
          </button>

          <table className="table table-bordered">
            <thead>
              <tr>
                <th>S.No</th>
                <th>MainHeading</th>
                <th>SubHeading</th>
                <th>Paragraph</th>
                <th>Video</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.map((item, index) => (
                <tr key={item._id}>
                  <td>{index + 1}</td>

                  <td>{item.mainHeading}</td>
                  <td>{item.subHeading}</td>

                  <td
                    dangerouslySetInnerHTML={{
                      __html: item.paragraph,
                    }}
                  ></td>

                  <td>
                    {item.video && (
                      <video width="120" controls>
                        <source
                          src={`${ENV_API_BASE_URL}/uploads/videos/${item.video}`}
                        />
                      </video>
                    )}
                  </td>

                  <td>
                    <button
                      className="btn btn-warning btn-sm me-2"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button>

                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() =>
                        handleDelete(item._id)
                      }
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {showForm && (
        <form onSubmit={handleSubmit}>
          <label>Main Heading</label>
          <input
            name="mainHeading"
            className="form-control mb-3"
            value={formData.mainHeading}
            onChange={handleChange}
            required
          />

          <label>Sub Heading</label>
          <input
            name="subHeading"
            className="form-control mb-3"
            value={formData.subHeading}
            onChange={handleChange}
            required
          />

          <label>Paragraph</label>
          <CKEditor
            editor={ClassicEditor}
            data={formData.paragraph}
            onChange={(e, editor) => {
              setFormData({
                ...formData,
                paragraph: editor.getData(),
              });
            }}
          />

          <label className="mt-3">Video</label>
          <input
            type="file"
            name="video"
            className="form-control"
            onChange={handleChange}
          />

          <button className="btn btn-success mt-3">
            {editId ? "Update" : "Save"}
          </button>
        </form>
      )}
    </div>
  );
}

export default TeacherTraining;
